import React from "react";
import Nav from "../../components/Navbar/Nav";
import Banner from "../../components/Banner/Banner";
import requests from "../../api/Requests";
import Row from "../../components/Movies/Row";

function Anime() {
	return (
		<div className="homeScreen">
			<Nav />
			<Banner fetchUrl={requests.fetchAnimePopular} />
			<div className="row-container">
				<Row title="Popular Anime" fetchUrl={requests.fetchAnimePopular} isLargeRow />
				<Row title="Top Rated Anime" fetchUrl={requests.fetchAnimeTopRated} isLargeRow />
				<Row title="Action" fetchUrl={requests.fetchAnimeAction} isLargeRow />
				<Row title="Comedy" fetchUrl={requests.fetchAnimeComedy} isLargeRow />
				<Row title="Drama" fetchUrl={requests.fetchAnimeDrama} isLargeRow />
				<Row title="Fantasy & Sci-Fi" fetchUrl={requests.fetchAnimeFantasy} isLargeRow />
				<Row title="Mystery" fetchUrl={requests.fetchAnimeMystery} isLargeRow />
				<Row title="Romance" fetchUrl={requests.fetchAnimeRomance} isLargeRow />
				<Row title="Anime Movies" fetchUrl={requests.fetchAnimeMovies} isLargeRow />
			</div>
		</div>
	);
}

export default Anime;
